<template>
  <div id="filters">
    <div class="filters__header">
      <div class="filters__header__arrow" @click="goToPrevStep">
        <sm-icon class="filters__header__arrow__green-icon" size="medium" icon="arrow-left"/>
      </div>
      <p class="filters__header__title">Elige los usuarios a los que deseas enviar tu oferta de crédito</p>
    </div>
    <div v-show="leadsSearchMsgError" class="filters__header__error-message" style="">{{ leadsSearchMsgError }}</div>
    <div class="filters">
    <div v-show="isLoading" class="filters_loading">
      <sm-inner-loading v-model="isLoading"/>
    </div>
    <div class="filters__left">
      <div class="filters__left__header">FILTROS</div>
        <div class="filters__left__body">

          <div class="filters__left__body__filter">
            <sm-checkbox required v-model="filter.shows.version" @click="filter.shows.versionArrow = !filter.shows.version" size="medium">
              País
            </sm-checkbox>
            <span @click="filter.shows.versionArrow = !filter.shows.version">
              <sm-icon v-show="filter.shows.versionArrow" icon="caret-down" />
            </span>
            <span @click="filter.shows.versionArrow = filter.shows.version">
              <sm-icon v-show="!filter.shows.versionArrow" icon="caret-up" />
            </span>
          </div>
          <transition name="filters-fade">
            <div v-show="filter.shows.version & filter.shows.versionArrow" class="filters__left__body__filter--no-border">
              <div class="filters__left__body__filter__container1">
                <div class="filters__left__body__filter__container1__left-column">
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.colombia.show" v-model="filter.opts.version.colombia.show" size="small">Colombia</sm-checkbox>
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.costaRica.show" v-model="filter.opts.version.costaRica.show" size="small">Costa Rica</sm-checkbox>
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.mexico.show" v-model="filter.opts.version.mexico.show" size="small">México</sm-checkbox>
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.spain.show" v-model="filter.opts.version.spain.show" size="small">España</sm-checkbox>
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.peru.show" v-model="filter.opts.version.peru.show" size="small">Perú</sm-checkbox>
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.panama.show" v-model="filter.opts.version.panama.show" size="small">Panamá</sm-checkbox>
                </div>

                <div class="filters__left__body__filter__container1__right-column">
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.chile.show" v-model="filter.opts.version.chile.show" size="small">Chile</sm-checkbox>
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.republicaDominicana.show" v-model="filter.opts.version.republicaDominicana.show" size="small">R. Dominicana</sm-checkbox>
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.usa.show" v-model="filter.opts.version.usa.show" size="small">USA</sm-checkbox>
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.argentina.show" v-model="filter.opts.version.argentina.show" size="small">Argentina</sm-checkbox>
                  <sm-checkbox :disabled="getAqlFilter.version && !filter.opts.version.other.show" v-model="filter.opts.version.other.show" size="small">Internacional</sm-checkbox>
                </div>
              </div>
            </div>
          </transition>

          <sm-select
            v-model="selectedCities"
            v-if="getAqlFilter.version && getAqlFilter.version[0] !== 'other'"
            :options="getCities"
            :multiple="true"
            :autocomplete="true"
            block
            size="small"
            class="filters__left__body--cities"
            selectClass="filters__left__body--city"
            :loading="isLoading ? true : false"
            placeholder="... Ingresa una ciudad"
          />

          <div v-show="noCountrySelectedError" class="filters__header__error-message" style="">{{ noCountrySelectedError }}</div>
          <div v-show="justOneCountryError" class="filters__header__error-message" style="">{{ justOneCountryError }}</div>

          <div class="filters__left__body__filter">
            <sm-checkbox v-model="filter.shows.total" @click="filter.shows.totalArrow = !filter.shows.total" size="medium">
              Facturación mensual
            </sm-checkbox>
            <span @click="filter.shows.totalArrow = !filter.shows.total">
              <sm-icon v-show="filter.shows.totalArrow" icon="caret-down" />
            </span>
            <span @click="filter.shows.totalArrow = filter.shows.total">
              <sm-icon v-show="!filter.shows.totalArrow" icon="caret-up" />
            </span>
          </div>
          <transition name="filters-fade">
            <div v-show="filter.shows.total && filter.shows.totalArrow" class="filters__left__body__filter--no-border">
              <div class="filters__left__body__filter__container2">
                <div class="billing-middle">
                  <div v-if="selectedCurrency" class="billing-middle__range">{{ monthlyBilling(filter.opts.total.from.key) }} - {{ monthlyBilling(filter.opts.total.to.key) }}</div>
                  <div v-else class="billing-middle__range">0</div>
                  <div class="multi-range-slider">
                    <input
                      @mouseover="totalHandler('left', true, false)"
                      @mouseleave="totalHandler('left', false, false); totalStop()"
                      @mousedown="totalHandler('left', false, true); totalSetLeft()"
                      @mouseup="totalHandler('left', true, false); totalStop()"
                      v-model="total.left.value"
                      type="range" id="input-left" min="0" max="100" step="0.1"
                    >
                    <input
                      @mouseover="totalHandler('right', true, false)"
                      @mouseleave="totalHandler('right', false, false); totalStop()"
                      @mousedown="totalHandler('right', false, true); totalSetRight()"
                      @mouseup="totalHandler('right', true, false); totalStop()"
                      v-model="total.right.value"
                      type="range" id="input-right" min="0" max="100" step="0.1"
                    >
                  </div>

                  <div class="slider">
                    <div class="track"></div>
                    <div class="range" :style="[{ left: total.thumb.left }, { right: total.thumb.right }]"></div>

                    <!--div id="left-date" class="slider-date" :class="[{ hover: total.left.isHover }, { active: total.left.isActive }]" :style="{ left: total.thumb.left }">{{ monthlyBilling(filter.opts.total.from.key) }}</div-->
                    <!--div id="right-date" class="slider-date" :class="[{ hover: total.right.isHover }, { active: total.right.isActive }]" :style="{ right: total.thumb.right }">{{ monthlyBilling(filter.opts.total.to.key) }}</div-->

                    <div class="thumb left" :class="[{ hover: total.left.isHover }, { active: total.left.isActive }]" :style="{ left: total.thumb.left }"></div>
                    <div class="thumb right" :class="[{ hover: total.right.isHover }, { active: total.right.isActive }]" :style="{ right: total.thumb.right }"></div>
                    <div v-show="selectedCurrency" class ="units">
                      <div class="units__range units__range--billing-left">0</div>
                      <div class="units__range units__range--billing-right">{{ currentCurrencyOpts.max }}</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </transition>

          <sm-select
            v-model="selectedCurrency"
            :error="selectedCurrency == undefined"
            :showErrorIcon="false"
            :options="currencies"
            :multiple="false"
            :autocomplete="true"
            block
            size="small"
            class="filters__left__body--cities"
            selectClass="filters__left__body--city"
            v-show="filter.shows.totalArrow"
            :loading="isLoading ? true : false"
            placeholder='Es necesario seleccionar una moneda'
          />

          <div class="filters__left__body__filter">
            <sm-checkbox v-model="filter.shows.sector" @click="filter.shows.sectorArrow = !filter.shows.sector" size="medium">
              Sectores de la industria
            </sm-checkbox>
            <span @click="filter.shows.sectorArrow = !filter.shows.sector">
              <sm-icon v-show="filter.shows.sectorArrow" icon="caret-down" />
            </span>
            <span @click="filter.shows.sectorArrow = filter.shows.sector">
              <sm-icon v-show="!filter.shows.sectorArrow" icon="caret-up" />
            </span>
          </div>
          <transition name="filters-fade">
            <div v-show="filter.shows.sector & filter.shows.sectorArrow" class="filters__left__body__filter--no-border">
              <div class="filters__left__body__filter__container1">
                <div class="filters__left__body__filter__container1__left-column">
                  <sm-checkbox v-model="showAllSectors" size="small">Todos</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.agricultureLivestock.show" style="{ 'font-size': '10px' }" size="small">Agricultura / Ganadería</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.foodGastronomy.show" size="small">Alimentación / Gastronomía</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.architectureConstruction.show" size="small">Arquitectura / Construcción</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.artsCrafts.show" size="small">Artes / Manualidades</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.automotiveAndParts.show" size="small">Automotores y partes</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.detalTrading.show" size="small">Comercio al detal</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.retail.show" size="small">Comercio al detalle</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.electronicCommerce.show" size="small">Comercio electrónico</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.consulting.show" size="small">Consultoría</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.entertainment.show" size="small">Entretenimiento</sm-checkbox>
                </div>

                <div class="filters__left__body__filter__container1__right-column">
                  <sm-checkbox v-model="filter.opts.sector.education.show" size="small">Educación</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.personalCareAestheticsHealth.show" size="small">Cuidado personal / Estética / Salud</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.hospitalityTourism.show" size="small">Hotelería / Turismo</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.realEstate.show" size="small">Inmobiliario</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.manufacturing.show" size="small">Manufactura</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.nonGovernmentalOrganization.show" size="small">Organización no gubernamental</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.advertisingDigitalMedia.show" size="small">Publicidad / Medios digitales</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.financialAccountingServices.show" size="small">Servicios contables o financieros</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.specializedServices.show" size="small">Servicios especializados</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.technologyTelecommunications.show" size="small">Tecnología / Telecomunicaciones</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.transportLogistics.show" size="small">Transporte / Logística</sm-checkbox>
                  <sm-checkbox v-model="filter.opts.sector.others.show" size="small">Otros</sm-checkbox>
                </div>
              </div>
            </div>
          </transition>

          <div class="filters__left__body__filter">
            <sm-checkbox v-model="filter.shows.kindOfPerson" @click="filter.shows.kindOfPersonArrow = !filter.shows.kindOfPerson" size="medium">
              Persona
            </sm-checkbox>
            <span @click="filter.shows.kindOfPersonArrow = !filter.shows.kindOfPerson">
              <sm-icon v-show="filter.shows.kindOfPersonArrow" icon="caret-down" />
            </span>
            <span @click="filter.shows.kindOfPersonArrow = filter.shows.kindOfPerson">
              <sm-icon v-show="!filter.shows.kindOfPersonArrow" icon="caret-up" />
            </span>
          </div>
          <transition name="filters-fade">
            <div v-show="filter.shows.kindOfPerson & filter.shows.kindOfPersonArrow" class="filters__left__body__filter--no-border">
              <div class="filters__left__body__filter__container1">
                <div class="filters__left__body__filter__container1__left-column">
                  <sm-checkbox v-model="filter.opts.kindOfPerson.legal.show" size="small">Jurídica</sm-checkbox>
                </div>

                <div class="filters__left__body__filter__container1__right-column">
                  <sm-checkbox v-model="filter.opts.kindOfPerson.natural.show" size="small">Natural</sm-checkbox>
                </div>
              </div>
            </div>
          </transition>

          <div class="filters__left__body__filter--no-border">
            <sm-checkbox v-model="filter.shows.dateRegistry" @click="filter.shows.dateRegistryArrow = !filter.shows.dateRegistry" size="medium">
              Antig&#252;edad en Alegra
            </sm-checkbox>
            <span @click="filter.shows.dateRegistryArrow = !filter.shows.dateRegistry">
              <sm-icon v-show="filter.shows.dateRegistryArrow" icon="caret-down" />
            </span>
            <span @click="filter.shows.dateRegistryArrow = filter.shows.dateRegistry">
              <sm-icon v-show="!filter.shows.dateRegistryArrow" icon="caret-up" />
            </span>
          </div>
          <transition name="filters-fade">
            <div v-show="filter.shows.dateRegistry & filter.shows.dateRegistryArrow" class="filters__left__body__filter--no-border">
              <div class="filters__left__body__filter__container2">
                <div class="middle">
                  <div class="multi-range-slider">
                    <input
                      @mouseover="monthsHandler('left', true, false)"
                      @mouseleave="monthsHandler('left', false, false); monthsStop()"
                      @mousedown="monthsHandler('left', false, true); monthsSetLeft()"
                      @mouseup="monthsHandler('left', true, false); monthsStop()"
                      v-model="months.left.value"
                      type="range" id="input-left" min="0" max="100"
                    >
                    <input
                      @mouseover="monthsHandler('right', true, false)"
                      @mouseleave="monthsHandler('right', false, false); monthsStop()"
                      @mousedown="monthsHandler('right', false, true); monthsSetRight()"
                      @mouseup="monthsHandler('right', true, false); monthsStop()"
                      v-model="months.right.value"
                      type="range" id="input-right" min="0" max="100"
                    >
                  </div>

                  <div class="slider">
                    <div class="track"></div>
                    <div class="range" :style="[{ left: months.thumb.left }, { right: months.thumb.right }]"></div>

                    <div id="left-date" class="slider-date" :class="[{ hover: months.left.isHover }, { active: months.left.isActive }]" :style="{ left: months.thumb.left }">{{ monthAndYear(filter.opts.dateRegistry.from.key) }}</div>
                    <div id="right-date" class="slider-date" :class="[{ hover: months.right.isHover }, { active: months.right.isActive }]" :style="{ right: months.thumb.right }">{{ monthAndYear(filter.opts.dateRegistry.to.key) }}</div>

                    <div class="thumb left" :class="[{ hover: months.left.isHover }, { active: months.left.isActive }]" :style="{ left: months.thumb.left }"></div>
                    <div class="thumb right" :class="[{ hover: months.right.isHover }, { active: months.right.isActive }]" :style="{ right: months.thumb.right }"></div>
                    <div class ="units">
                      <div class="units__range units__range--months-left">2012</div>
                      <div class="units__range units__range--months-right">Hoy</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </transition>

        </div>
      </div>
      <div class="filters__right">
        <div class="filters__right__header">PROSPECTOS</div>
        <div class="filters__right__body">
          <div v-if="billingChartdata.labels.length" class="filters__right__chart">
            <div class="filters__right__chart__title">EMPRESAS SEGÚN FACTURACIÓN</div>
            <Bar-chart
              class="filters__right__chart--bar__container"
              :chartdata="billingChartdata"
              :options="billingOptions"
            />
          </div>

          <div v-if="cityPieChartdata.labels.length" class="filters__right__chart">
            <div class="filters__right__chart__title">EMPRESAS SEGÚN CIUDAD</div>
            <Pie-chart
              class="filters__right__chart--sector"
              :chartdata="cityPieChartdata"
              :options="cityPieOptions"
            />
          </div>

          <div v-if="sectorPieChartdata.labels.length" class="filters__right__chart">
            <div class="filters__right__chart__title">EMPRESAS SEGÚN SECTOR</div>
            <Pie-chart
              class="filters__right__chart--city"
              :chartdata="sectorPieChartdata"
              :options="sectorPieOptions"
            />
          </div>

          <div v-if="barChartdata.labels.length" class="filters__right__chart">
            <div class="filters__right__chart__title">EMPRESAS SEGÚN ANTIG&#252;EDAD EN ALEGRA</div>
            <Bar-chart
              class="filters__right__chart--bar__container"
              :chartdata="barChartdata"
              :options="barOptions"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from './charts/PieChart.js'
import BarChart from './charts/BarChart.js'
import interpolateColors from '@/utils/color-generator.js'
import { interpolateYlGnBu, interpolateYlOrRd } from 'd3-scale-chromatic'
import currencies from '../constants/currencies.json'

const theNow = new Date()
const theBegining = new Date(2012, 0, 1)
let timeout

export default {
  name: 'Filters',
  components: {
    PieChart,
    BarChart
  },
  created () {
    if (this.isFilterActive) {
      const { shows, opts } = this.$store.getters.filter
      this.filter = { ...this.filter, opts, shows }
      const millisBegining = theBegining.valueOf()
      const left = (new Date(opts.dateRegistry.from.key).valueOf() - millisBegining) / this.months.toMillis.length
      const right = (new Date(opts.dateRegistry.to.key).valueOf() - millisBegining) / this.months.toMillis.length

      this.months.left.value = left
      this.months.right.value = right
      this.monthsSetLeft()
      this.monthsSetRight()
    }
  },
  mounted () {
    const { thumb, range } = this.months

    document.querySelector('.thumb.left').style.left = thumb.left + '%'
    document.querySelector('.thumb.right').style.right = thumb.right + '%'
    document.querySelector('.range').style.left = range.left + '%'
    document.querySelector('.range').style.right = range.right + '%'
  },
  data () {
    return {
      sectorPieChartdata: {
        labels: ['No data'],
        datasets: [
          {
            label: 'EMPRESAS SEGÚN SECTOR',
            backgroundColor: '#eaedf74c',
            data: [1]
          }
        ]
      },
      sectorPieOptions: {
        elements: {
          arc: {
            borderWidth: 0
          }
        },
        tooltips: {
          enabled: false,
          callbacks: {
            label: function (tooltipItem, data) {
              const index = tooltipItem.index
              let label = data.labels[index] || ''

              if (label) {
                label = label === 'null' ? 'Sin categoría: ' : label + ': '
              }

              label += data.datasets[0].data[index] + ' %'
              return label
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        // rotation: 2 * Math.PI,
        // cutoutPercentage: 30,
        // circumference: Math.PI,
        legend: {
          position: 'right',
          display: false
        },
        title: {
          display: false
        }
      },
      cityPieChartdata: {
        labels: ['No data'],
        datasets: [
          {
            label: 'EMPRESAS SEGÚN SECTOR',
            backgroundColor: '#eaedf74c',
            data: [1]
          }
        ]
      },
      cityPieOptions: {
        elements: {
          arc: {
            borderWidth: 0
          }
        },
        tooltips: {
          enabled: false,
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.labels[tooltipItem.index] || ''

              if (label) {
                label += ': '
              }
              label += data.datasets[0].data[tooltipItem.index] + ' %'
              return label
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        // rotation: 2 * Math.PI,
        // cutoutPercentage: 30,
        // circumference: Math.PI,
        legend: {
          position: 'right',
          display: false
        },
        title: {
          display: false
        }
      },
      billingChartdata: {
        labels: [''],
        datasets: [
          {
            // label: 'EMPRESAS SEGÚN FACTURACIÓN',
            backgroundColor: '#eaedf74c',
            data: [1]
          }
        ]
      },
      billingOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false,
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.datasets[0].data[tooltipItem.index] + ' %'
              return label
            }
          }
        },
        scales: {
          xAxes: [{
            display: false,
            position: 'bottom',
            gridLines: {
              display: false,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            },
            scaleLabel: {
              display: false,
              labelString: '',
              fontStyle: 'bold',
              fontSize: '10'
            }
          }],
          yAxes: [{
            display: false,
            position: 'left',
            id: 'first-y-axis',
            type: 'linear',
            gridLines: {
              display: false,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            },
            scaleLabel: {
              display: false,
              labelString: '% de prospectos',
              fontStyle: 'bold',
              fontSize: '10'
            },
            ticks: {
              beginAtZero: true,
              // stepValue: 1,
              autoSkip: false,
              callback: function (value, index, values) {
                return index % 2 === 0 && value > 0 ? value : ''
              }
            }
          }]
        },
        legend: {
          display: false
        },
        title: {
          display: false
        }
      },
      barChartdata: {
        labels: [''],
        datasets: [
          {
            // label: 'EMPRESAS SEGÚN ANTIGUEDAD EN ALEGRA',
            backgroundColor: '#eaedf74c',
            data: [1]
          }
        ]
      },
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false,
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.datasets[0].data[tooltipItem.index] + ' %'
              return label
            }
          }
        },
        scales: {
          xAxes: [{
            display: false,
            position: 'bottom',
            gridLines: {
              display: false,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            },
            scaleLabel: {
              display: false,
              labelString: 'Antiguedad en Alegra (meses)',
              fontStyle: 'bold',
              fontSize: '10'
            }
          }],
          yAxes: [{
            display: false,
            position: 'left',
            id: 'first-y-axis',
            type: 'linear',
            gridLines: {
              display: false,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            },
            scaleLabel: {
              display: false,
              labelString: '% de prospectos',
              fontStyle: 'bold',
              fontSize: '10'
            },
            ticks: {
              beginAtZero: true,
              // stepValue: 1,
              autoSkip: false,
              callback: function (value, index, values) {
                return index % 2 === 0 && value > 0 ? value : ''
              }
            }
          }]
        },
        legend: {
          display: false
        },
        title: {
          display: false
        }
      },
      filter: {
        shows: {
          annual_turnover: false,
          annual_turnoverArrow: false,
          version: true,
          versionArrow: true,
          sector: false,
          sectorArrow: false,
          kindOfPerson: false,
          kindOfPersonArrow: false,
          dateRegistry: false,
          dateRegistryArrow: false,
          total: false,
          totalArrow: false
        },
        opts: {
          annual_turnover: {
            amount: {
              show: false, key: '0'
            }
          },
          version: {
            colombia: {
              show: false, key: 'colombia'
            },
            costaRica: {
              show: false, key: 'costaRica'
            },
            mexico: {
              show: false, key: 'mexico'
            },
            spain: {
              show: false, key: 'spain'
            },
            peru: {
              show: false, key: 'peru'
            },
            panama: {
              show: false, key: 'panama'
            },
            chile: {
              show: false, key: 'chile'
            },
            republicaDominicana: {
              show: false, key: 'republicaDominicana'
            },
            usa: {
              show: false, key: 'usa'
            },
            argentina: {
              show: false, key: 'argentina'
            },
            other: {
              show: false, key: 'other' // international
            }
          },
          sector: {
            agricultureLivestock: {
              show: false, key: 'Agricultura / Ganaderia'
            },
            foodGastronomy: {
              show: false, key: 'Alimentacion / Gastronomia'
            },
            architectureConstruction: {
              show: false, key: 'Arquitectura / Construccion'
            },
            artsCrafts: {
              show: false, key: 'Artes / Manualidades'
            },
            automotiveAndParts: {
              show: false, key: 'Automotores y partes'
            },
            detalTrading: {
              show: false, key: 'Comercio al detal'
            },
            retail: {
              show: false, key: 'Comercio al detalle'
            },
            electronicCommerce: {
              show: false, key: 'Comercio electronico'
            },
            consulting: {
              show: false, key: 'Consultoria'
            },
            personalCareAestheticsHealth: {
              show: false, key: 'Cuidado personal / Estetica / Salud'
            },
            education: {
              show: false, key: 'Educacion'
            },
            entertainment: {
              show: false, key: 'Entretenimiento'
            },
            hospitalityTourism: {
              show: false, key: 'Hoteleria / Turismo'
            },
            realEstate: {
              show: false, key: 'Inmobiliario'
            },
            manufacturing: {
              show: false, key: 'Manufactura'
            },
            nonGovernmentalOrganization: {
              show: false, key: 'Organizacion no gubernamental'
            },
            advertisingDigitalMedia: {
              show: false, key: 'Publicidad / Medios digitales'
            },
            financialAccountingServices: {
              show: false, key: 'Servicios contables o financieros'
            },
            specializedServices: {
              show: false, key: 'Servicios especializados'
            },
            technologyTelecommunications: {
              show: false, key: 'Tecnologia / Telecomunicaciones'
            },
            transportLogistics: {
              show: false, key: 'Transporte / Logistica'
            },
            others: {
              show: false, key: 'Otros'
            }
          },
          kindOfPerson: {
            legal: {
              show: false, key: '1'
            },
            natural: {
              show: false, key: '2'
            }
          },
          dateRegistry: {
            from: {
              show: true, key: '2012-01-01'
            },
            to: {
              show: true, key: theNow.toJSON().split('T')[0]
            }
          },
          total: {
            from: {
              show: true, key: 0
            },
            to: {
              show: true, key: '*'
            }
          },
          time: {
            months: {
              show: true, key: `${theNow.getMonth() + 12 * (theNow.getFullYear() - 2012)} Meses`
            }
          },
          billing: {
            amount: {
              show: true, key: '$500 MOOOS'
            }
          }
        }
      },
      months: {
        length: theNow.getMonth() + 1 + /* current year's months */ 11 - theBegining.getMonth() + 1 + /* begining year's months */ (theNow.getYear() - theBegining.getYear() - 1) * 12 /* Months between the now and the begining */,

        interval: false,
        toMillis: {
          length: (theNow.valueOf() - theBegining.valueOf()) / 100
        },

        left: {
          value: 0,
          isHover: false,
          isActive: false
        },

        right: {
          value: 100, // range points
          isHover: false,
          isActive: false
        },

        thumb: {
          left: 0, // in %
          right: 0 // in %
        },

        range: {
          min: 0,
          max: 100,
          left: 0, // in %
          right: 0 // in %
        }
      },
      total: {
        length: 100,

        interval: false,
        toMillis: {
          length: 5000000 // extremo máximo de la facturacion mensual entre 100 (moneda COP)
        },

        left: {
          value: 0,
          isHover: false,
          isActive: false
        },

        right: {
          value: 100, // range points
          isHover: false,
          isActive: false
        },

        thumb: {
          left: 0, // in %
          right: 0 // in %
        },

        range: {
          min: 0,
          max: 100,
          left: 0, // in %
          right: 0 // in %
        }
      },
      showAllSectors: false,
      aqlFilter: {
        version: null,
        cities: null,
        sector: null,
        kindOfPerson: null,
        dateRegistry: null,
        total: null,
        currency: null
      },
      selectedCities: [],
      noCountrySelectedError: false,
      justOneCountryError: false,
      selectedCurrency: {
        text: 'COP',
        value: 'COP'
      }
    }
  },
  watch: {
    'filter.shows.dateRegistry': function (show) {
      const millisBegining = theBegining.valueOf()
      this.filter.opts.dateRegistry.from.key = new Date(millisBegining + this.months.toMillis.length * this.months.left.value).toJSON().split('T')[0]
      this.filter.opts.dateRegistry.to.key = new Date(millisBegining + this.months.toMillis.length * this.months.right.value).toJSON().split('T')[0]
    },
    'months.left.value': function (l) {
      const millisBegining = theBegining.valueOf()
      this.filter.opts.dateRegistry.from.key = new Date(millisBegining + this.months.toMillis.length * l).toJSON().split('T')[0]
    },
    'months.right.value': function (r) {
      const millisBegining = theBegining.valueOf()
      this.filter.opts.dateRegistry.to.key = new Date(millisBegining + this.months.toMillis.length * r).toJSON().split('T')[0]
    },
    monthsRange: function (range) {
      this.filter.opts.time.months.key = range
    },
    'filter.shows.total': function (show) {
      this.filter.opts.total.from.key = this.total.toMillis.length * this.total.left.value
      this.filter.opts.total.to.key = this.total.toMillis.length * this.total.right.value
    },

    'total.left.value': function (l) {
      const { currency } = this.getAqlFilter
      if (!currency) {
        this.filter.opts.total.from.key = 0
      } else if (currency[0] === 'COP') {
        if (l < 21) {
          this.filter.opts.total.from.key = 5 * l * 1000000
        } else {
          this.filter.opts.total.from.key = Math.round(400 * l / 79 - 500 / 79) * 1000000
        }
      } else if (currency[0] === 'MXN') {
        this.filter.opts.total.from.key = l * 10000
      }
    },
    'total.right.value': function (r) {
      const { currency } = this.getAqlFilter
      if (!currency) {
        this.filter.opts.total.to.key = 0
      } else if (currency[0] === 'COP') {
        if (r < 21) {
          this.filter.opts.total.to.key = 5 * r * 1000000
        } else {
          this.filter.opts.total.to.key = Math.round(400 * r / 79 - 500 / 79) * 1000000
        }
      } else if (currency[0] === 'MXN') {
        this.filter.opts.total.to.key = r * 10000
      }
    },
    totalRange: function (range) {
      this.filter.opts.billing.amount.key = range
    },
    showAllSectors: function (value) {
      const sector = this.filter.opts.sector

      Object.keys(sector).map(key => {
        sector[key].show = value
      })
    },
    getAqlFilter (value) {
      const country = value.version

      const nowAqlFilter = JSON.stringify(value)
      const beforeAqlFilter = JSON.stringify(this.aqlFilter)
      const isNewAqlFilter = !Object.is(nowAqlFilter, beforeAqlFilter)

      if (country) {
        if (country.length > 1) {
          this.justOneCountryError = 'Por favor seleccionar solamente un país'
          return
        }

        this.justOneCountryError = ''

        const nowCountry = { v: value.version }
        const beforeCountry = { v: this.aqlFilter.version }
        const isNewCountry = !Object.is(JSON.stringify(nowCountry), JSON.stringify(beforeCountry))

        if (isNewCountry) {
          this.$store.dispatch('getCities', String(country))
        }
      } else {
        if (this.selectedCities.length) {
          this.selectedCities = []
        }

        this.noCountrySelectedError = 'Es necesario seleccionar un país'
        return
      }

      this.noCountrySelectedError = ''

      if (timeout) {
        clearTimeout(timeout)
      }

      const nowFilterShows = JSON.stringify(this.$store.getters.filter.shows)
      const nextFilterShows = JSON.stringify(this.filter.shows)
      const isNewFilterShows = !Object.is(nowFilterShows, nextFilterShows)

      if (isNewAqlFilter) {
        timeout = setTimeout(() => {
          this.$store.commit('filter', { filter: this.filter }) // filter

          const wasMonthlyBillingrequested = value.total && value.currency

          if (wasMonthlyBillingrequested) {
            this.$store.dispatch('aqlFilter', { aqlFilter: value, wasMonthlyBillingrequested }) // AQL filter
          }

          this.$store.dispatch('aqlFilter', { aqlFilter: value }) // AQL filter
          this.aqlFilter = value
        }, 1100)
      } else if (isNewFilterShows) {
        const maybeUsers = this.$store.getters.maybeUsers
        this.$store.commit('filter', { nowFilterShows }) // filter
        this.$store.commit('maybeUsers', { ...maybeUsers, isThereNewData: true })
      }
    },
    maybeUsers (value) {
      const { bySector, byCity, byAntiquity, byMonthlyBilling, isThereNewData = false, backgroundColor = '#eaedf74c' } = value

      const sectorKeys = Object.keys(bySector)
      const isThereSectors = sectorKeys.length && this.filter.shows.sector

      const cityKeys = Object.keys(byCity)
      // const isThereCities = cityKeys.length && this.filter.shows.city

      this.sectorPieOptions.tooltips.enabled = isThereNewData
      this.sectorPieChartdata = {
        labels: isThereSectors ? sectorKeys : [''],
        datasets: [
          {
            // label: 'EMPRESAS SEGÚN SECTOR',
            showLine: isThereSectors ? isThereNewData : false,
            backgroundColor: isThereSectors && isThereNewData ? this.colorsGenerator(sectorKeys.length, interpolateYlOrRd) : backgroundColor,
            data: isThereSectors ? Object.values(bySector) : [1]
          }
        ]
      }

      this.cityPieOptions.tooltips.enabled = sectorKeys.length ? isThereNewData : false
      this.cityPieChartdata = {
        labels: cityKeys.length ? cityKeys : [''],
        datasets: [
          {
            // label: 'EMPRESAS SEGÚN CIUDAD',
            showLine: cityKeys.length ? isThereNewData : false,
            backgroundColor: sectorKeys.length && isThereNewData ? this.colorsGenerator(cityKeys.length, interpolateYlGnBu) : backgroundColor,
            data: cityKeys.length ? Object.values(byCity) : [1]
          }
        ]
      }

      const byAntiquityValues = Object.values(byAntiquity)
      const isTherebyAntiquityValues = byAntiquityValues.reduce((total, num) => total + num) && this.filter.shows.dateRegistry
      this.barOptions.tooltips.enabled = isTherebyAntiquityValues ? isThereNewData : false

      this.barOptions.scales.yAxes[0].display = isTherebyAntiquityValues ? isThereNewData : false
      this.barOptions.scales.yAxes[0].gridLines.display = isTherebyAntiquityValues ? isThereNewData : false
      this.barOptions.scales.yAxes[0].scaleLabel.display = isTherebyAntiquityValues ? isThereNewData : false

      this.barOptions.scales.xAxes[0].display = isTherebyAntiquityValues ? isThereNewData : false
      this.barOptions.scales.xAxes[0].gridLines.display = isTherebyAntiquityValues ? isThereNewData : false
      this.barOptions.scales.xAxes[0].scaleLabel.display = isTherebyAntiquityValues ? isThereNewData : false

      this.barChartdata = {
        labels: isTherebyAntiquityValues ? Object.keys(byAntiquity) : [''],
        datasets: [
          {
            // label: 'EMPRESAS SEGÚN ANTIGUEDAD EN ALEGRA',
            backgroundColor: isTherebyAntiquityValues && isThereNewData ? '#e9c46a' : backgroundColor,
            data: isTherebyAntiquityValues ? byAntiquityValues : [1]
          }
        ]
      }

      const byMonthlyBillingValues = Object.values(byMonthlyBilling)
      const isTherebyMonthlyBillingValues = byMonthlyBillingValues.reduce((total, num) => total + num) && this.filter.shows.total
      this.billingOptions.tooltips.enabled = isTherebyMonthlyBillingValues ? isThereNewData : false

      this.billingOptions.scales.yAxes[0].display = isTherebyMonthlyBillingValues ? isThereNewData : false
      this.billingOptions.scales.yAxes[0].gridLines.display = isTherebyMonthlyBillingValues ? isThereNewData : false
      this.billingOptions.scales.yAxes[0].scaleLabel.display = isTherebyMonthlyBillingValues ? isThereNewData : false

      this.billingOptions.scales.xAxes[0].display = isTherebyMonthlyBillingValues ? isThereNewData : false
      this.billingOptions.scales.xAxes[0].gridLines.display = isTherebyMonthlyBillingValues ? isThereNewData : false
      this.billingOptions.scales.xAxes[0].scaleLabel.display = isTherebyMonthlyBillingValues ? isThereNewData : false

      let billingChartLabel
      if (this.selectedCurrency.text === 'COP') {
        billingChartLabel = 'Facturación mensual (Millones de COP/mes)'
      } else if (this.selectedCurrency.text === 'MXN') {
        billingChartLabel = 'Facturación mensual (Miles de MXN/mes)'
      }
      this.billingOptions.scales.xAxes[0].scaleLabel.labelString = billingChartLabel

      this.billingChartdata = {
        labels: isTherebyMonthlyBillingValues ? Object.keys(byMonthlyBilling) : [''],
        datasets: [
          {
            // label: 'EMPRESAS SEGÚN FACTURACIÓN',
            backgroundColor: isTherebyMonthlyBillingValues && isThereNewData ? '#e9c46a' : backgroundColor,
            data: isTherebyMonthlyBillingValues ? byMonthlyBillingValues : [1]
          }
        ]
      }
    },
    selectedCurrency (newCurrency) {
      this.total.left.value = 0
      this.filter.opts.total.from.key = 0
      if (!newCurrency) {
        this.total.right.value = 0
        this.filter.opts.total.to.key = 0
      } else {
        this.total.right.value = 100
        this.filter.opts.total.to.key = this.currentCurrencyOpts.max
      }
      this.totalStop()
    }
  },
  computed: {
    monthsRange () {
      const { left: { value: L }, right: { value: R }, length } = this.months
      const minor = L * length / 100
      const major = R * length / 100
      return `${Math.round(Math.abs(major - minor))} Meses`
    },
    totalRange () {
      const { left: { value: L }, right: { value: R }, length } = this.total
      const minor = L * length / 100
      const major = R * length / 100
      return `$${Math.round(Math.abs(major - minor))} M`
    },
    isFilterActive () {
      return this.$store.getters.isFilterActive
    },
    getAqlFilter () {
      const { opts, shows } = this.filter

      function trueKeys2Array (opts) {
        if (!opts) { return [] }
        return Object.values(opts).filter(el => el.show).map(el => el.key)
      }

      const aqlFilter = {
        version: null,
        city: null,
        sector: null,
        kindOfPerson: null,
        dateRegistry: null,
        total: null,
        currency: null
      }

      Object.keys(aqlFilter).map(key => {
        const arr = trueKeys2Array(opts[key])
        aqlFilter[key] = shows[key] && arr.length ? arr : null
      })

      if (this.selectedCities.length && aqlFilter.version) {
        const auxSelectedCities = this.selectedCities.filter(city => !!city)
        aqlFilter.city = auxSelectedCities.map(city => city.text)
      } else {
        aqlFilter.city = null
      }

      if (this.selectedCurrency && aqlFilter.total) {
        aqlFilter.currency = [this.selectedCurrency.value]
      } else {
        aqlFilter.total = null
      }

      return aqlFilter
    },
    maybeUsers () {
      return this.$store.getters.maybeUsers
    },
    isLoading () {
      return this.$store.getters.isLoading
    },
    getCities () {
      return this.$store.getters.cities
    },
    leadsSearchMsgError () {
      return this.$store.getters.leadsSearchMsgError
    },
    currencies () {
      return [
        {
          text: 'COP',
          value: 'COP'
        },
        {
          text: 'MXN',
          value: 'MXN'
        }
      ]
    },
    globalCurrencies () {
      return currencies
    },
    currentCurrencyOpts () {
      let opts = {
        symbol: ''
      }

      const { currency } = this.getAqlFilter

      if (!currency) {
        return opts
      }

      if (currency[0] === 'COP') {
        opts = {
          symbol: '$',
          max: 500000000
        }
      } else if (currency[0] === 'MXN') {
        opts = {
          symbol: '$',
          max: 100000
        }
      }

      return opts
    }
  },
  methods: {
    monthsSetLeft () {
      if (!this.months.interval) {
        this.months.interval = setInterval(() => {
          let value = Math.min(this.months.left.value, this.months.right.value - 1)

          if (value < 0) { value = 0 } else if (value > 100) { value = 90 }

          this.months.left.value = value
          this.months.thumb.left = value + '%'
          this.months.range.left = value + '%'
        }, 30)
      }
    },
    totalSetLeft () {
      if (!this.total.interval) {
        this.total.interval = setInterval(() => {
          let value = Math.min(this.total.left.value, this.total.right.value - 1)

          if (value < 0) { value = 0 } else if (value > 100) { value = 90 }

          this.total.left.value = value
          this.total.thumb.left = value + '%'
          this.total.range.left = value + '%'
        }, 30)
      }
    },
    monthsSetRight () {
      if (!this.months.interval) {
        this.months.interval = setInterval(() => {
          let value = Math.max(this.months.right.value, this.months.left.value + 1)

          if (value < 0) { value = 0 } else if (value > 100) { value = 90 }

          this.months.right.value = value
          this.months.thumb.right = (100 - value) + '%'
          this.months.range.right = (100 - value) + '%'
        }, 30)
      }
    },
    totalSetRight () {
      if (!this.total.interval) {
        this.total.interval = setInterval(() => {
          let value = Math.max(this.total.right.value, this.total.left.value + 1)

          if (value < 0) { value = 0 } else if (value > 100) { value = 90 }

          this.total.right.value = value
          this.total.thumb.right = (100 - value) + '%'
          this.total.range.right = (100 - value) + '%'
        }, 30)
      }
    },
    monthsStop () {
      clearInterval(this.months.interval)
      this.months.interval = false

      let { left: { value: L }, right: { value: R } } = this.months

      L = Number(L)
      R = Number(R)

      if (Math.abs(L - R) < 10) { L = L - 5; R = R + 5 }
      if (R < 0) { R = 0 } else if (R > 100) { R = 90 }
      if (L < 0) { L = 0 } else if (L > 100) { L = 90 }

      const min = Math.min(L, R - 1)
      const max = Math.max(R, L + 1)
      this.months.left.value = min
      this.months.thumb.left = min + '%'
      this.months.range.left = max + '%'

      this.months.right.value = max
      this.months.thumb.right = (100 - max) + '%'
      this.months.range.right = (100 - max) + '%'
    },
    totalStop () {
      clearInterval(this.total.interval)
      this.total.interval = false

      let { left: { value: L }, right: { value: R } } = this.total

      L = Number(L)
      R = Number(R)

      if (Math.abs(L - R) < 2) { L = L - 1; R = R + 1 }
      if (R < 0) { R = 0 } else if (R > 100) { R = 100 }
      if (L < 0) { L = 0 } else if (L > 100) { L = 100 }

      const min = Math.min(L, R - 1)
      const max = Math.max(R, L + 1)
      this.total.left.value = min
      this.total.thumb.left = min + '%'
      this.total.range.left = max + '%'

      this.total.right.value = max
      this.total.thumb.right = (100 - max) + '%'
      this.total.range.right = (100 - max) + '%'
    },
    monthsHandler (side, isHover, isActive) {
      this.months[side].isHover = isHover
      this.months[side].isActive = isActive
    },
    totalHandler (side, isHover, isActive) {
      this.total[side].isHover = isHover
      this.total[side].isActive = isActive
    },
    colorsGenerator (dataLength, colorScale) {
      const colorRangeInfo = {
        colorStart: 0.25,
        colorEnd: 1,
        useEndAsStart: false
      }

      return interpolateColors(dataLength, colorScale, colorRangeInfo)
    },
    goToPrevStep () {
      this.$store.commit('goToPrevStep')
    },
    monthlyBilling (amount) {
      const { symbol } = this.currentCurrencyOpts
      if (amount > 1000000) {
        return `${symbol} ` + amount / 1000000 + ' M'
      } else {
        return `${symbol} ` + amount
      }
    },
    monthAndYear (date) {
      const [y, m] = date.split('-')
      let month
      switch (m) {
        case '01':
          month = 'Enero'
          break
        case '02':
          month = 'Febrero'
          break
        case '03':
          month = 'Marzo'
          break
        case '04':
          month = 'Abril'
          break
        case '05':
          month = 'Mayo'
          break
        case '06':
          month = 'Junio'
          break
        case '07':
          month = 'Julio'
          break
        case '08':
          month = 'Agosto'
          break
        case '09':
          month = 'setiembre'
          break
        case '10':
          month = 'Octubre'
          break
        case '11':
          month = 'Noviembre'
          break
        case '12':
          month = 'Diciembre'
          break
      }

      return month + ', ' + y
    },
    slugify (str) {
      const map = {
        a: 'á|à|ã|â|À|Á|Ã|Â',
        e: 'é|è|ê|É|È|Ê',
        i: 'í|ì|î|Í|Ì|Î',
        o: 'ó|ò|ô|õ|Ó|Ò|Ô|Õ',
        u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        c: 'ç|Ç',
        n: 'ñ|Ñ'
      }

      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern)
      }

      return str
    }
  }
}
</script>

<style>
.filters__left__body--cities {
  width: 100%;
}

.filters__left__body--city {
  text-align: start;
}

.filters__left__body__filter__container1__left-column {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.filters__left__body__filter__container1__right-column {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.filters__header__error-message {
  color: #e85e42;
  font-size: 85%;
  font-weight: 500;

  background: #fff2f3;
  margin: 10px 0;
  padding: 5px;
  width: 100%;
}

.filters__header {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 20px;
}

.filters__header__arrow {
  color: #00b19d;
  font-size: large;
  font-weight: bold;
  line-height: 2;
  text-align: center;

  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  height: fit-content;
  width: 37px;
}

.filters__header__arrow__green-icon {
  color: #00b19d;
}

.filters__header__arrow__green-icon:hover {
  opacity: 0.7;
}

.filters__header__title {
  color: #00535e;
  font-size: 15px;
  font-weight: 400;
  text-align: center;
  width: calc(100% - 90px);
}

.filters-fade-enter-active {
  animation-direction: normal;
  animation-duration: .3s;
  animation-iteration-count: 1;
  animation-name: filters-fade;
  transition-timing-function: ease-in;
}

.filters-fade-leave-active {
  animation-direction: reverse;
  animation-duration: .3s;
  animation-iteration-count: 1;
  animation-name: filters-fade;
  transition-timing-function: linear;
}

@keyframes filters-fade {
  0% {
    opacity: 0;
  }
  100% {
  opacity: 1;
  }
}

.middle {
  margin: 50px 0;
  max-width: 500px;
  position: relative;
  width: calc(100% - 35px);
}

.billing-middle {
  margin-bottom: 27px;
  max-width: 500px;
  position: relative;
  width: calc(100% - 35px);
  margin-top: 17px;
}

.billing-middle__range {
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #707070;
  margin-bottom: 30px;
}

.slider {
  height: 3px;
  margin: 0 5px;
  position: relative;
  z-index: 1;
}

.slider > .track {
  background-color: #cccccc;
  border-radius: 5px;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}

.slider > .range {
  background-color: #00b19d;
  border-radius: 5px;
  bottom: 0;
  left: 0%;
  position: absolute;
  right: 0%;
  top: 0;
  z-index: 2;
}

.slider > .thumb {
  background-color: #00b19d;
  border-radius: 50%;
  box-shadow: 0 0 0 7px rgba(0,0,0,.1);
  height: 10px;
  position: absolute;
  top: 6.5px;
  transition: box-shadow .3s ease-in-out;
  width: 10px;
  z-index: 3;
}

.slider > .thumb.left {
  left: 0%;
  transform: translate(-5px, -10px);
}

.slider > .thumb.right {
  right: 0%;
  transform: translate(5px, -10px);
}

.slider > .thumb.hover {
  box-shadow: 0 0 0 7px rgba(0,177,157,.1);
}

.slider > .thumb.active {
  box-shadow: 0 0 0 5px rgba(0,177,157,.2);
}

input[type=range] {
  height: 3px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  -webkit-appearance: none;
  width: 100%;
  z-index: 2;
}

input[type=range]::-webkit-slider-thumb {
  background-color: red;
  border: 0 none;
  border-radius: 0;
  height: 10px;
  pointer-events: all;
  -webkit-appearance: none;
  width: 10px;
}

/*
#input-left {
  top: -100px;
}

#input-right {
  top: -50px;
}
*/

.slider-date {
  color: #00b19d;
  position: absolute;
  top: 6.5px;
  width: 50px;
  text-align: left;
  z-index: 3;
  font-weight: 600;
  font-size: 12px;
}

#left-date {
  top: -47px;
}

#right-date {
  top: 10px;
}

.units {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.units__range {
  color: #999999;
  font-size: 12px;
  font-weight: 400;

  position: relative;
}

.units__range--billing-left {
  left: -3px;
}

.units__range--billing-right {
  left: 15px;
}

.units__range--months-left {
  left: -16px;
  top: 7px;
}

.units__range--months-right {
  left: 10px;
  top: -30px;
}

.units__range--billing-left {
  left: -4px;
  top: 13px;
}

.units__range--billing-right {
  left: 14px;
  top: 13px;
}

.filters {
  border: 1px solid #cccccc;
  display: flex;
  flex-direction: row;
}

.filters_loading {
  align-items: center;
  display: flex;
  height: calc(100% - 525px);
  justify-content: center;
  max-width: 714px;
  position: absolute;
  width: calc(100% - 310px);
  z-index: 9;
}

.filters__left {
  align-items: center;
  border-color: #cccccc;
  border-style: solid;
  border-width: 0 1px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 40 0px;
  width: 300px;
}

.filters__left__header {
  color: #00535e;
  font-size: 12px;
  font-weight: bold;
  text-align: left;

  background-color: #eaedf74c;
  margin-bottom: 5px;
  padding: 10px 0 10px 20px;
  width: 100%;
}

.filters__left__body {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
}

.filters__left__body__filter {
  text-align: left;

  border-color: #cccccc;
  border-style: solid;
  border-width: 0 0 1px 0;
  margin-bottom: 6.5px;
  padding-bottom: 2px;
  width: 100%;
}

.filters__left__body__filter--no-border {
  text-align: left;

  border-color: #cccccc;
  border-width: 0 0 1px 0;
  margin-bottom: 10px;
  width: 100%;
}

.filters__left__body__filter__container1 {
  display: flex;
  flex-direction: row;
}

.filters__left__body__filter__container2 {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.filters__left__body__filter__container2__header {
  color: #808080;
  font-size: 23px;
  position: relative;
  top: 20px;
}

.filters__left__body__filter__container2__gray-bar {
  border: 1px solid #b3b3b3;
  width: calc(100% - 40px);
}

.filters__right {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: calc(100% - 298px);
}

.filters__right__body {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-evenly;
  padding: 10px 0;
  width: 100%;
}

.filters__right__chart {
  border-color: #f2f2f2;
  border-radius: 10px;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0px 4px 5px 1px rgba(0,0,0,.1);
  margin-bottom: 10px;
  padding: 8px;
  transition: box-shadow .3s ease-in-out;
  width: calc(100% - 18px);
}

.filters__right__chart--city {
  height: 220px;
  position: relative;
  width: 100%;
}

.filters__right__chart--sector {
  height: 220px;
  position: relative;
  width: 100%;
}

.filters__right__chart--bar__container {
  height: 320px;
  position: relative;
  width: 100%;
}

.filters__right__header {
  color: #00535e;
  font-size: 12px;
  font-weight: bold;
  text-align: left;

  background-color: #eaedf74c;
  padding: 10px 0 10px 10px;
  width: 100%;
}

.filters__right__chart__title {
  color: #00535e;
  font-size: 10px;
  font-weight: bold;
  text-align: left;

  border-color: #bcbcbc;
  border-style: solid;
  border-width: 0 0 1px 0;
  margin-bottom: 5px;
  padding: 5px 0px;
  width: 100%;
}

.filters__right__leads-amount {
  color: #00535e;
  font-size: 50px;
  font-weight: 500;

  position: relative;
  top: 20%;
}
</style>
